import { useMeQuery } from '@frameio/graphql-client/generated';

/**
 * The intent of this hook is to provide a temporary way to read the current User data explicitly from the cache.
 * This should be the preferred method for accessing this data, and if you explicitly need to fetch over the network
 * then you can use the Me query directly. This is a stopgap solution until we add a new context to provide the current
 * User ID similar to other providers like `ActiveAccountId`, which then can be used to read off a fragment.
 * @returns The current Me data in the cache
 */
export const useMeCachedQuery = () => {
  return useMeQuery({
    fetchPolicy: 'cache-only',
    nextFetchPolicy: 'cache-only',
  });
};
